import React, {useEffect} from 'react'
import Aos from "aos"
import "aos/dist/aos.css"
import '../CSS/Home.css'
import Typed from 'react-typed';
import homeani from '../Image/homeAni.png';



const Home = () => {
   useEffect(() => {
      Aos.init({duration:2000});
   }, []);
    return (
      <>
      <div className="backHome">
          <div className="containerHome">
                  <div data-aos="zoom-in-right" className="col-6 mx-auto intro">
                     <h1>Hey,</h1>
                     <h2><span className='changeColor'>Suprodip</span> Here,</h2>

                     <Typed
                        className="typedText"
                        strings={["Web Developer","Coder","CP Enthusiast","UI/Ux Enthusiast"]}
                        typeSpeed={40}
                        backSpeed={60}
                        loop
                     />
                     <div className='buttonDiv'>
                        <button className='custom-btnHome btn-6'>My Resume</button>
                     </div>
                  </div> 
                  <div data-aos="zoom-in-left" className="col-6 mx-auto">
                     <img src={homeani} className="image" alt="home page png"/>
                  </div>
         </div>
      </div> 
      </>      
    )
}

export default Home;

